import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, 1, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  return (
    <div className="product-detail">
      <div className="min-h-80vh px-4 lg-px-27px xxl-px-89px">
        <div className="min-h-45px ml-full-width w-screen bg-f7f7f7 hidden md-block">
          <div className="breadcrumbs max-w-[1400px] mx-auto py-2 md-py-4">
            <Link to="/" onClick={toTop}>Home</Link>
            <span className="px-2">/</span>
            <Link to="/shop" onClick={toTop}>Shop</Link>
            <span className="px-2">/</span>
            <span>{product.name}</span>
          </div>
        </div>

        <div className="cms-root_cmsFullWidth-5e3">
          <div className="cms-root-63a">
            <div className="richContent-root-63a">
              <div className="product-detail-content">
                <div className="product-detail-image-section">
                  <div className="product-detail-main-image">
                    <img src={product.images[selectedImage]} alt={product.name} />
                  </div>
                  {product.images.length > 1 && (
                    <div className="product-detail-thumbnails">
                      {product.images.map((image, index) => (
                        <button
                          key={index}
                          className={`thumbnail ${index === selectedImage ? 'active' : ''}`}
                          onClick={() => setImage(index)}
                        >
                          <img src={image} alt={`${product.name} ${index + 1}`} />
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                <div className="product-detail-info">
                  <div className="product-detail-category">{product.category}</div>
                  <h1 className="product-detail-title">{product.name}</h1>
                  <div className="product-detail-rating">
                    <span className="rating-stars">★★★★★</span>
                    <span className="rating-reviews">({product.reviews} reviews)</span>
                  </div>
                  <div className="product-detail-price">£{product.price}</div>
                  
                  {product.description && (
                    <div className="product-detail-description">
                      {product.description.map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                      ))}
                    </div>
                  )}

                  {product.size && product.size.length > 0 && (
                    <div className="product-detail-options">
                      <div className="options-label">Size</div>
                      <div className="options-buttons">
                        {product.size.map((size, index) => (
                          <button
                            key={index}
                            className={`option-button ${selectedSize === size ? 'active' : ''}`}
                            onClick={() => setSelectedSize(size)}
                          >
                            {size}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {product.colors && product.colors.length > 0 && (
                    <div className="product-detail-options">
                      <div className="options-label">Color</div>
                      <div className="options-buttons">
                        {product.colors.map((color, index) => (
                          <button
                            key={index}
                            className={`option-button ${selectedColor === color ? 'active' : ''}`}
                            onClick={() => setSelectedColor(color)}
                          >
                            {color}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  <button className="add-to-cart-button" onClick={handleAddToCart}>
                    Add to Cart
                  </button>

                  {product.Features && (
                    <div className="product-detail-features">
                      <h3>Product Details</h3>
                      <ul>
                        {product.Features.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
